The human readable name of the organization.
